require('re-tree');
require('./ng-device-detector');
module.exports = 'ng.deviceDetector';